<template>
  <div class="popup" v-if="taskMultiShows" >
  <div class="onedrive4Buiness-errors" v-if="taskMultiShows">
    <el-carousel ref="carousel" :interval="0" arrow="never" indicator-position="none">
       <div class = "content-box">
       <div class="text-box">
        <p>{{ $t('language.common.oneDrive4BusinessContent') }}</p>
      </div>
      <!-- <div class="title-long-text">
        <span class="semicircle-box"></span>
      </div> -->
    </div>
   </el-carousel>
    <!-- 新增框 -->
    <div class="new-box">
      <!-- 相册框 -->
      <div class="photo-gallery">
        <img :src="steps[activeIndex].image" class="gallery-image" />
      </div>
      <div class="tips-box"><p v-html="$t(steps[activeIndex].tip)"></p></div>
      <div class="title-long-text">
      <div class="semicircle-box">
      <div class = "title-text"><p>{{ $t(steps[activeIndex].title) }}</p></div>
      </div>
    </div>
    </div>
    <div class="note-box">
      <div class="nested-line">
        <span class="note-text">{{ $t('language.common.onedriveBusinessContentNote') }}</span>
      </div>
    </div>
    <!-- 删除按钮 -->
    <div class="carousel-delete-button" @click="hideAndReset()">
      <div class="carousel-delete-icon"></div>
    </div>
    <div class="footer">
      <div class="indicators">
        <span 
          v-for="(item, index) in steps" 
          :key="index" 
          :class="{active: activeIndex === index}"
          @click="setActive(index)">
        </span>
      </div>
      <button class="up-button" v-if="activeIndex > 0" @click="upStep">{{$t('language.common.upStep')}}</button>
        <button class="next-button" @click="isLastStep ? hideAndReset() : nextStep()">
          {{ isLastStep ? $t('language.common.complete') : $t('language.common.nextStep')}}
        </button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      taskMultiShows: false,
      activeIndex: 0,
      steps: [
        { 
          title: 'language.common.oneDrive4BusinessStep1', 
          tip: 'language.common.oneDrive4BusinessTips1',
          image: require('@/assets/images/onedriveBuiness/step-01.png')  // 这里添加你的图片路径
        },
        { 
          title: 'language.common.oneDrive4BusinessStep2', 
          tip: 'language.common.oneDrive4BusinessTips2',
          image: require('@/assets/images/onedriveBuiness/step-03.png')
        },
      ],
      isLastStep: false, // 标志位：是否显示完成按钮
    };
  },
  methods: {
    show() {
      this.taskMultiShows = true;
    },
    hideAndReset() {
      this.taskMultiShows = false;
      this.resetCarousel();
    },
    resetCarousel() {
      this.activeIndex = 0;
      this.isLastStep = false;
      this.$refs.carousel.setActiveItem(0);
    },
    // 下一步按钮
    nextStep() {
      this.activeIndex = (this.activeIndex + 1) % this.steps.length;
      this.$refs.carousel.setActiveItem(this.activeIndex);
      this.isLastStep = this.activeIndex === this.steps.length - 1; // 判断是否是最后一页
    },
    // 上一步按钮
    upStep() {
      this.activeIndex = (this.activeIndex - 1 + this.steps.length) % this.steps.length;
      this.$refs.carousel.setActiveItem(this.activeIndex);
      this.isLastStep = this.activeIndex === this.steps.length - 1; // 判断是否是最后一页
    },
    setActive(index) {
      this.activeIndex = index;
      this.$refs.carousel.setActiveItem(index);
      this.isLastStep = index === this.steps.length - 1; // 判断是否是最后一页
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.images.length;
    },
    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.images.length) % this.images.length;
    },
  }
};
</script>

<style>

.onedrive4Buiness-errors {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 800px;
  height: 627px;
  opacity: 1;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #98a3e6;
}


.footer {
  position: absolute;
  left: 30px;
  top: 565px;
  /* width: 740px; */
  width: calc(100% - 60px); /* 根据父容器宽度调整 */
  height: 30px;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1;
}

.text-box {
  position: relative; /* 使用相对定位代替绝对定位 */
  width: 97%;
  height: 100%;
  opacity: 1;
  font-family: Arial;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0em;
  color: #3D3D3D;
  z-index: 0;
  left: 20px;
  display: flex; /* Flexbox 属性 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  text-align: left; /* 确保文本左对齐 */
  word-break: break-word; /* 确保单词在容器宽度达到时换行 */
  white-space: normal; /* 确保正常换行 */
}

.text-box p {
  color: #3D3D3D;
  margin: 0; /* 移除段落的默认外边距 */
  width: 100%; /* 确保段落占满容器宽度 */
}

.semicircle-box {
  position: absolute;
  left: 30px;
  top: -44px;
  width: 70px;
  height: 34px;
  border-radius: 0px 30px 30px 0px;
  opacity: 1;
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  gap: 10px;
  background: #5562B4;
  z-index: 2;
  overflow: hidden;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
}


.tips-box {
  position: absolute;
  left: 172px;
  top: 44px;
  width: 599px;
  /* height: 36px; */
  height: 18%;
  opacity: 1;
  font-family: Arial;
  font-size: 16px;
  font-weight: bold;
  line-height: normal;
  letter-spacing: 0em;
  z-index: 1;
  display: flex;
  align-items: center;
  text-align: center;
  word-break: break-word; /* 确保单词在容器宽度达到时换行 */
  white-space: normal; /* 确保正常换行 */
}

.tips-box p {
  color: #3D3D3D !important;
  text-align: left;
}

.title-text {
  position: absolute;
  /* left: 32px;
  top: 3px; */
  /* width: 30%;
  height: 18px; */
  text-align: center; /* 文本居中 */
  width: 100%;
  height: auto;
  opacity: 1;
  font-family: Microsoft YaHei UI;
  font-size: 14px;
  font-weight: bold;
  line-height: normal;
  letter-spacing: 0.03em;
  color: #FFFFFF;
  z-index: 1;
}

.title-text p {
  color: #FFFFFF !important;
}

.title-long-text {
  position: absolute;
  left: 0px;
  top: 105px;
  width: 740px;
  height: 58px;
  opacity: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 20px;
  align-self: stretch;
  z-index: 1;
}

.content-box {
  position: absolute;
  left: 0px;
  top: 40px;
  width: 761px;
  height: 89px;
  opacity: 1;
  display: flex;
  flex-direction: column;
  justify-content: center; /* 垂直居中 */
  align-items: center; /* 水平居中 */
  padding: 0px;
  gap: 20px;
  z-index: 0;
}
.indicators {
  position: absolute;
  left: 341.5px;
  top: 10px;
  width: 82px;
  height: 10px;
  opacity: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 16px;
  z-index: 0;
}

.indicators span {
  width: 8px;
  height: 8px;
  background: #D8D8D8;
  border-radius: 50%;
  cursor: pointer;
  opacity: 1;
}

.indicators span.active {
  width: 10px;
  height: 10px;
  background: #5562B4;
  opacity: 1;
}

.next-button {
  position: absolute;
  left: 618px;
  top: 0px;
  width: 122px;
  height: 30px;
  border-radius: 2px;
  opacity: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 40px;
  gap: 5px;
  background: #5562B4;
}

.next-button:hover {
  background: #3250C9;
}

.next-button:active {
  background: #1836B0;
}


.next-button p, .up-button p {
  position: static;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  opacity: 1;
  font-family: Microsoft YaHei UI;
  font-size: 16px;
  font-weight: bold;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
  color: #FFFFFF;
}


.up-button {
  position: static;
  left: 0px;
  top: 0px;
  width: 122px;
  height: 30px;
  border-radius: 2px;
  opacity: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 40px;
  gap: 5px;
  background: #FFFFFF;
  box-sizing: border-box;
  border: 1px solid #C1CBE3;
  cursor: pointer;
  color: #5562B4;
  font-family: Arial;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
  z-index: 1;
}

.up-button:hover {
  background: rgba(80, 101, 187, 0.05);
  border: 1px solid #C1CBE3;
}

.up-button:active {
  background: rgba(80, 101, 187, 0.1);
  border: 1px solid #C1CBE3;
}


.photo-gallery {
  position: absolute;
  left: 30px;
  top: 142px;
  width: 740px;
  height: 320px;
  border: 1px solid #98A3E6;
  display: flex;
  justify-content: center;
  align-items: center;
}


.gallery-image {
  max-width: 100%;
  max-height: 100%;
}

.new-box {
  position: absolute;
  left: 0px;
  top: 72px;
  width: 800px;
  height: 495px;
  opacity: 1;
}

.note-box {
  position: absolute;
left: 0px;
top: 0px;
width: 781px;
height: 40px;
opacity: 1;

/* 自动布局 */
display: flex;
flex-direction: row;
align-items: center;
padding: 0px 5px 0px 12px;
gap: 10px;

/* 主色#00 */
/* 样式描述：重点 */
background: #5562B4;
  z-index: 0;
}

.nested-line {
  position: absolute;
  left: 12px;
  top: 10px;
  width: 743px;
  height: 16px;
  opacity: 1;
  display: flex;
  flex-direction: column;
  padding: 0px;
  flex-grow: 1;
  z-index: 0;
  color: #FFFFFF;
}
.note-text {
  /* 自动布局子元素 */
position: static;
left: 0px;
top: 0px;
width: 32px;
height: 16px;
opacity: 1;
	
/* 14B */
font-family: Arial;
font-size: 14px;
font-weight: bold;
line-height: normal;
letter-spacing: 0em;
	
color: #FFFFFF;
	
z-index: 0;
}
/* 删除按钮的样式 */
.carousel-delete-button {
  position: absolute;
  left: 762px;
  top: 5px;
  width: 30px;
  height: 30px;
  opacity: 1;
  background: #5562B4;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 2;
}

.carousel-delete-icon {
  position: relative;
  width: 12px;
  height: 12px;
}

.carousel-delete-icon::before,
.carousel-delete-icon::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12px;
  height: 1.5px;
  background-color: #FFFFFF; /* 修改为白色 */
  transform-origin: center;
}

.carousel-delete-icon::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.carousel-delete-icon::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/list_onedrivebuiness_folder_error.vue